module.exports = __webpack_public_path__ + "img/publik-logobackground.0135609c.png";